module.exports = __webpack_public_path__ + "static/media/etiqaLogoDesktop.a9209501.png";